<template>
    <div v-if="chips.length" class="message-filters" aria-label="Фильтры при отправке">
        <span
            v-for="chip in chips"
            :key="chip.id"
            class="filter-chip"
        >
            <ChatIcon
                v-if="chip.icon"
                :name="chip.icon"
                :size="10"
                color="#888780"
            />
            {{ chip.label }}
        </span>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import ChatIcon from '@/components/chat/icons/ChatIcon.vue'

const props = defineProps({
    filterContext: {
        type: Object,
        default: null,
    },
})

const chips = computed(() => {
    const ctx = props.filterContext
    if (!ctx) return []
    if (Array.isArray(ctx.chips) && ctx.chips.length) {
        return ctx.chips
    }
    return []
})
</script>

<style scoped>
.message-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

.filter-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 4px;
    background: #F4F2EC;
    border: 1px solid #E8E6E0;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #5F5E5A;
}
</style>
